import React, { useEffect, useState } from 'react';
import dashboardStyle from '../studentDashboard/dashboard.module.css'
import { AppBar, Box, Button, CircularProgress, MenuItem, Select, Tab, Tabs } from '@mui/material';
import FooterComponent from '../../component/FooterComponent'
import courseStyle from '../courses/courses.module.css'
import { useDispatch, useSelector } from 'react-redux';
import { getDashboardData, getPurchasedCourse, getWishlistCourse } from '../redux/dashboardSlice';
import { AffiliategetProfile, getCoursesWithoutParamsAffiliate, getWebinarsWithoutParamsAffiliate } from '../redux/affiliateSlice';
import ErrorPage from '../../component/ErrorPage';
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import Settings from '../studentDashboard/Settings';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { getCoursesWithoutParams, getUrlsForAffiliate } from '../redux/affiliateSlice';
import * as yup from "yup";
import { useFormik } from 'formik';
import { unwrapResult } from '@reduxjs/toolkit';
import AffiliateSettings from '../studentDashboard/AffiliateSettings';
import { Snackbar, Alert } from '@mui/material';

const AffiliateDashboard = () => {
    const dispatch = useDispatch();
    const dashboardData = useSelector((state) => state.dashboard);
    const isRefresh = useSelector((state) => state.dashboard.isRefresh);
    const userProfile = useSelector((state) => state.affiliate);
    const getUserProfile = userProfile?.affiliate;

    console.log(getUserProfile, "getUserProfile")

    const [tabValue, setTabValue] = useState(0);
    const [search, setSearch] = useState('');
    const [order, setOrder] = useState('');
    const [filterBy, setFilterBy] = useState('');
    const [courseData, setCourseData] = useState();
    const [webinarData, setWebinarData] = useState(); // New state for webinar data
    const [isLoading, SetIsLoading] = useState(false)
    const [isWebinarLoading, setIsWebinarLoading] = useState(false) // New loading state for webinar
    const [generatedUrls, setGeneratedUrls] = useState({});
    const [generatedWebinarUrls, setGeneratedWebinarUrls] = useState({}); // New state for webinar URLs
    const [openSnackbar, setOpenSnackbar] = useState(false);

    // Course URL Schema
    const courseSchema = yup.object().shape({
        courseId: yup.string().required("select a course"),
    })

    // Webinar URL Schema
    const webinarSchema = yup.object().shape({
        webinarId: yup.string().required("select a webinar"),
    })

    // Course URL Formik
    const {
        errors: courseErrors,
        values: courseValues,
        handleChange: handleCourseChange,
        touched: courseTouched,
        setValues: setCourseValues,
        handleBlur: handleCourseBlur,
        handleSubmit: handleCourseSubmit,
        setFieldValue: setCourseFieldValue,
    } = useFormik({
        initialValues: {
            courseId: "",
        },
        validationSchema: courseSchema,
        onSubmit: (values) => {
            generateCourseUrls(values)
        }
    })

    // Webinar URL Formik
    const {
        errors: webinarErrors,
        values: webinarValues,
        handleChange: handleWebinarChange,
        touched: webinarTouched,
        setValues: setWebinarValues,
        handleBlur: handleWebinarBlur,
        handleSubmit: handleWebinarSubmit,
        setFieldValue: setWebinarFieldValue,
    } = useFormik({
        initialValues: {
            webinarId: "",
        },
        validationSchema: webinarSchema,
        onSubmit: (values) => {
            generateWebinarUrls(values)
        }
    })

    const generateCourseUrls = async (values) => {
        SetIsLoading(true)
        try {
            const resultAction = await dispatch(getUrlsForAffiliate(values));
            const data = unwrapResult(resultAction);
            console.log(data?.affiliateLinks, "Generated Course Link");
            setGeneratedUrls(data?.affiliateLinks);
        } catch (error) {
            console.log(error);
        } finally {
            SetIsLoading(false)
        }
    }

    const generateWebinarUrls = async (values) => {
        setIsWebinarLoading(true)
        try {
            // You'll need to create a similar API for webinar URLs
            // For now, using the same function but with webinar data
            const resultAction = await dispatch(getUrlsForAffiliate({ ...values, type: 'webinar' }));
            const data = unwrapResult(resultAction);
            console.log(data?.affiliateLinks, "Generated Webinar Link");
            setGeneratedWebinarUrls(data?.affiliateLinks);
        } catch (error) {
            console.log(error);
        } finally {
            setIsWebinarLoading(false)
        }
    }

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleCopy = (url) => {
        navigator.clipboard.writeText(url);
        setOpenSnackbar(true);
    };

    useEffect(() => {
        dispatch(AffiliategetProfile())
    }, [dispatch])

    useEffect(() => {
        dispatch(getDashboardData())
    }, [dispatch])

    useEffect(() => {
        let data = {
            search,
            order,
            filterBy,
            sortBy: "createdAt"
        }
        dispatch(getPurchasedCourse(data))
    }, [dispatch, search, order, filterBy]);

    useEffect(() => {
        dispatch(getWishlistCourse())
    }, [dispatch, isRefresh])

    // Fetch Course Data
    useEffect(() => {
        const fetchCourseData = async () => {
            try {
                const data = await dispatch(getCoursesWithoutParamsAffiliate()).unwrap();
                console.log(data);
                if (data) {
                    setCourseData(data);
                }
            } catch (error) {
                console.error("Error fetching courses:", error.message || error);
            }
        };

        let isMounted = true;
        if (isMounted) {
            fetchCourseData();
        }

        return () => {
            isMounted = false;
        };
    }, [dispatch]);

    // Fetch Webinar Data - You'll need to implement this API
    // Fetch Webinar Data
    useEffect(() => {
        const fetchWebinarData = async () => {
            try {
                console.log("Starting webinar fetch...");
                setIsWebinarLoading(true);

                const data = await dispatch(getWebinarsWithoutParamsAffiliate()).unwrap();
                console.log("Webinar API Response:", {
                    data: data,
                    length: data?.length,
                    type: typeof data,
                    isArray: Array.isArray(data)
                });

                setWebinarData(data || []);
            } catch (error) {
                console.error("Error fetching webinars:", error);
                setWebinarData([]);
            } finally {
                setIsWebinarLoading(false);
            }
        };

        fetchWebinarData();
    }, [dispatch]);

    console.log(generatedUrls, "generate");


    console.log("webinaaaaaaaaaaaaaaaaaaaar", webinarData)

    return (
        <div>
            <div className={dashboardStyle.mainContainer} style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
                <div className={dashboardStyle.dashContainer}>
                    <div className={dashboardStyle.studentProfile}>
                        {getUserProfile?.profileImg?.[0]?.length > 0 ? (
                            <div>
                                <img
                                    src={getUserProfile?.profileImg?.[0]}
                                    style={{ width: 60, height: 60, borderRadius: 30, objectFit: 'cover' }}
                                    alt='Avatar'
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = "https://www.svgrepo.com/show/486506/user-profile-filled.svg";
                                    }}
                                />
                            </div>
                        ) : (
                            <img
                                src="https://www.svgrepo.com/show/486506/user-profile-filled.svg"
                                alt="User Avatar"
                                style={{ width: 60, height: 60, borderRadius: 30, objectFit: 'cover' }}
                            />
                        )}
                        <div>
                            <p className={dashboardStyle.profileText}>
                                {getUserProfile?.name}
                            </p>
                            <span>
                                {getUserProfile?.email}
                            </span>
                        </div>
                    </div>
                    <div className={dashboardStyle.bottomLine} />
                    <div className={dashboardStyle.tabsStyle}>
                        <Box sx={{ overflowX: 'auto', width: '100%' }}>
                            <AppBar position="static" color="transparent" elevation={0}>
                                <Tabs
                                    value={tabValue}
                                    onChange={handleTabChange}
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    sx={{
                                        width: '100%',
                                        '& .MuiTabs-flexContainer': {
                                            justifyContent: { xs: 'flex-start', sm: 'center', md: 'center', lg: 'center' },
                                            gap: { xs: '10px', sm: '10px', md: '20px', lg: '40px' },
                                        },
                                        '& .MuiTab-root': {
                                            textTransform: 'capitalize',
                                            fontFamily: 'Figtree',
                                            fontSize: { xs: '12px', sm: '14px', md: '16px', lg: '18px' },
                                            fontWeight: '500',
                                            lineHeight: '22px',
                                            textAlign: 'left',
                                            color: '#6E7485',
                                            paddingLeft: { xs: '5px', sm: '10px', md: '15px', lg: '25px' },
                                            '&.Mui-selected': {
                                                color: '#1D2026',
                                                fontWeight: '600',
                                                '&.MuiTab-iconWrapper': {
                                                    color: '#1D83F8',
                                                },
                                            },
                                        },
                                        '& .MuiTabs-indicator': {
                                            backgroundColor: '#1D83F8',
                                            height: '2px',
                                            width: '50px',
                                            left: 'calc(50% - 25px)',
                                            transition: 'left 0.3s ease',
                                        },
                                    }}
                                >
                                    <Tab label="Course URL's" />
                                    <Tab label="Webinar URL's" />
                                    <Tab label="My Profile" />
                                </Tabs>
                            </AppBar>
                        </Box>
                    </div>
                </div>
            </div>

            {/* Course URL Tab */}
            {tabValue === 0 && (
                <div className={dashboardStyle.tabContaineraffiliate}>
                    <div className={dashboardStyle.generateurlmain} >
                        <span>Generate course URL</span>
                        <div className={dashboardStyle.affiliatesortByStyle}>
                            <div style={{ width: "80%" }}>
                                <label className={courseStyle.sortText}>Select Course</label>
                                <Select
                                    IconComponent={ArrowDropDownIcon}
                                    displayEmpty
                                    defaultValue=''
                                    name='courseId'
                                    value={courseValues.courseId}
                                    onChange={(e) => setCourseFieldValue('courseId', e.target.value)}
                                    sx={{
                                        width: '100%',
                                        height: '48px',
                                        color: '#8D8D8D',
                                        fontFamily: 'Poppins',
                                        lineHeight: '20px',
                                        fontSize: '14px',
                                        outline: 'none !important',
                                        padding: '20px',
                                        borderRadius: '16px',
                                        border: '1px solid var(--Gray-100, #E0E2E7) !important',
                                        ".MuiSelect-select": {
                                            padding: '12px 1px !important'
                                        },
                                        ".MuiOutlinedInput-notchedOutline": {
                                            border: "none !important"
                                        },
                                    }}
                                >
                                    <MenuItem value="" disabled hidden>Select a Course</MenuItem>
                                    {courseData?.map((course, index) => (
                                        <MenuItem key={index} value={course?._id}>
                                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                                <>{course.title}</>
                                                {course.batch && <> (batch - {course.batch})</>}
                                            </div>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>
                            <div className={dashboardStyle.generatebutton}
                                onClick={handleCourseSubmit}
                                style={{ width: "120px", display: "flex", justifyContent: "center", alignItems: "center", height: "49px" }}
                            >
                                {isLoading ? <CircularProgress size={20} /> : <span>Generate</span>}
                            </div>
                        </div>
                        <div className={dashboardStyle.urlHeading}>Generated URL's</div>
                        <div className={dashboardStyle.socialLinksContainer}>
                            {Object.entries(generatedUrls).map(([name, url], index) => (
                                <div key={index} className={dashboardStyle.socialLink}>
                                    <label className={dashboardStyle.socialLabel}>{name} </label>
                                    <div className={dashboardStyle.socialInputContainer}>
                                        <span className={dashboardStyle.prefix} style={{ fontSize: "14px", fontWeight: "500" }}>https://</span>
                                        <input type="text" value={url} readOnly className={dashboardStyle.socialInput} />
                                        <ContentCopyIcon className={dashboardStyle.copyIcon} onClick={() => handleCopy(url)} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {/* Webinar URL Tab */}
            {/* Webinar URL Tab */}
          {/* Webinar URL Tab */}
{tabValue === 1 && (
    <div className={dashboardStyle.tabContaineraffiliate}>
        <div className={dashboardStyle.generateurlmain}>
            <span>Generate webinar URL</span>

            {isWebinarLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                    <CircularProgress />
                    <span style={{ marginLeft: '10px' }}>Loading webinars...</span>
                </div>
            ) : (
                <>
                    <div className={dashboardStyle.affiliatesortByStyle}>
                        <div style={{ width: "80%" }}>
                            <label className={courseStyle.sortText}>Select Webinar</label>
                            <Select
                                IconComponent={ArrowDropDownIcon}
                                displayEmpty
                                defaultValue=''
                                name='webinarId'
                                value={webinarValues.webinarId}
                                onChange={(e) => setWebinarFieldValue('webinarId', e.target.value)}
                                sx={{
                                    width: '100%',
                                    height: '48px',
                                    color: '#8D8D8D',
                                    fontFamily: 'Poppins',
                                    lineHeight: '20px',
                                    fontSize: '14px',
                                    outline: 'none !important',
                                    padding: '20px',
                                    borderRadius: '16px',
                                    border: '1px solid var(--Gray-100, #E0E2E7) !important',
                                    ".MuiSelect-select": {
                                        padding: '12px 1px !important'
                                    },
                                    ".MuiOutlinedInput-notchedOutline": {
                                        border: "none !important"
                                    },
                                }}
                            >
                                <MenuItem value="" disabled hidden>
                                    {webinarData && webinarData.length > 0 ? "Select a Webinar" : "No webinars available"}
                                </MenuItem>
                                {webinarData && webinarData.length > 0 ? (
                                    webinarData
                                        .filter(webinar => !webinar.isExpired) // Only show non-expired webinars
                                        .map((webinar, index) => (
                                            <MenuItem key={index} value={webinar?._id}>
                                                <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                                    <>{webinar.title}</>
                                                    {webinar.batch && <> (batch - {webinar.batch})</>}
                                                    {/* <span style={{ 
                                                        fontSize: '12px', 
                                                        color: '#4CAF50',
                                                        marginLeft: '8px'
                                                    }}>
                                                        Active
                                                    </span> */}
                                                </div>
                                            </MenuItem>
                                        ))
                                ) : (
                                    <MenuItem value="" disabled>
                                        No webinars available for affiliate linking
                                    </MenuItem>
                                )}
                            </Select>
                        </div>
                        <div
                            className={dashboardStyle.generatebutton}
                            onClick={webinarData && webinarData.filter(webinar => !webinar.isExpired).length > 0 ? handleWebinarSubmit : undefined}
                            style={{
                                width: "120px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "49px",
                                opacity: webinarData && webinarData.filter(webinar => !webinar.isExpired).length > 0 ? 1 : 0.5,
                                cursor: webinarData && webinarData.filter(webinar => !webinar.isExpired).length > 0 ? 'pointer' : 'not-allowed'
                            }}
                        >
                            {isWebinarLoading ? <CircularProgress size={20} /> : <span>Generate</span>}
                        </div>
                    </div>

                    {!isWebinarLoading && webinarData && webinarData.filter(webinar => !webinar.isExpired).length === 0 && (
                        <div style={{
                            textAlign: 'center',
                            padding: '40px',
                            color: '#666',
                            border: '1px dashed #ddd',
                            borderRadius: '8px',
                            marginTop: '20px'
                        }}>
                            No active webinars available for affiliate linking at the moment.
                        </div>
                    )}
                </>
            )}

            <div className={dashboardStyle.urlHeading}>Generated URL's</div>
            <div className={dashboardStyle.socialLinksContainer}>
                {Object.entries(generatedWebinarUrls).map(([name, url], index) => (
                    <div key={index} className={dashboardStyle.socialLink}>
                        <label className={dashboardStyle.socialLabel}>{name} </label>
                        <div className={dashboardStyle.socialInputContainer}>
                            <span className={dashboardStyle.prefix} style={{ fontSize: "14px", fontWeight: "500" }}>https://</span>
                            <input type="text" value={url} readOnly className={dashboardStyle.socialInput} />
                            <ContentCopyIcon className={dashboardStyle.copyIcon} onClick={() => handleCopy(url)} />
                        </div>
                    </div>
                ))}
                {Object.keys(generatedWebinarUrls).length === 0 && !isWebinarLoading && (
                    <div style={{ textAlign: 'center', color: '#999', padding: '20px' }}>
                        No webinar URLs generated yet
                    </div>
                )}
            </div>
        </div>
    </div>
)}
            {/* My Profile Tab */}
            {tabValue === 2 && (
                <div className={dashboardStyle.tabContainer} style={{ marginTop: 20 }}>
                    <AffiliateSettings getUserProfile={getUserProfile} />
                </div>
            )}

            <div className={dashboardStyle.footerStyle}>
                <FooterComponent />
            </div>

            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
                    Copied to clipboard!
                </Alert>
            </Snackbar>
        </div>
    )
}

export default AffiliateDashboard